export default __webpack_public_path__ + "static/media/2277.51ed80bd.png";